import React, { useEffect, useState } from 'react';
import './WeatherWidget.css';

const WeatherWidget = () => {
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    // Grab the user's location once and pull current conditions
    if (!navigator.geolocation) {
      setError('Geolocation not supported');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        fetch(
          `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&units=imperial&appid=b1dc3139b4c62e33369929efe9c25dd2`
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.cod === 200) {
              setWeather(data);
            } else {
              setError('Unable to fetch weather');
            }
          })
          .catch(() => setError('Weather API failed'));
      },
      () => setError('Location access denied')
    );
  }, []);

  if (error || !weather) return null; // Keep layout clean if we can't show weather

  const icon = weather.weather[0].icon;
  const description = weather.weather[0].main;
  const temp = Math.round(weather.main.temp);
  const high = Math.round(weather.main.temp_max);
  const low = Math.round(weather.main.temp_min);
  const cityName = weather.name; // City label comes straight from the API response

  return (
    <div className="weather-widget">
      <img
        src={`https://openweathermap.org/img/wn/${icon}@2x.png`}
        alt={description}
      />
      <div className="weather-info">
        <div className="city-name">{cityName}</div>
        <div className="temperature">{temp}°F</div>
        <div className="sub-info">H: {high}° L: {low}°</div>
      </div>
    </div>
  );
};

export default WeatherWidget;
